import { render, staticRenderFns } from "./LogoKfzteileComSvg.vue?vue&type=template&id=aacfb800&"
import script from "./LogoKfzteileComSvg.vue?vue&type=script&lang=js&"
export * from "./LogoKfzteileComSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports